export default __webpack_public_path__ + "static/media/Quinze.a8814f2a.jpg";